<template>
  <Logo class="logo" v-bind="$attrs" />
</template>

<script>
import Logo from '@/svg/icon-glogo.svg'
export default {
  name: 'GenoLogo',
  components: { Logo }
}
</script>

